// src/services/StudentPortal/studentApi.js
import axios from "axios";
import baseURL from "../../config";
import { STUDENT_STORAGE_KEYS } from "./studentStorageKeys";

// Student/parent sessions authenticate against a separate Laravel guard
// (auth:student_api, OTP login) from the staff "token" used everywhere else
// in this app, so they get their own axios instance and their own token key
// (localStorage "studentToken") instead of sharing src/services/api.js.
const studentApi = axios.create({
  baseURL: baseURL + "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

studentApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(STUDENT_STORAGE_KEYS.TOKEN);
  if (token) config.headers["Authorization"] = "Bearer " + token;

  // Confirmed against the real backend (2026-10-22): most student/* endpoints
  // 404 with "Organization not found" without this header, and separately
  // expect `student_id` as an explicit param even though the token already
  // identifies the student. Both are set once in StudentSessionContext right
  // after login (from the flat student/details response) and attached here
  // so individual service calls don't need to pass them manually.
  const organizationId = localStorage.getItem(STUDENT_STORAGE_KEYS.ORGANIZATION_ID);
  if (organizationId) config.headers["organization-id"] = organizationId;

  const sessionId = localStorage.getItem(STUDENT_STORAGE_KEYS.SESSION_ID);
  if (sessionId) config.headers["session-id"] = sessionId;

  // student_id is NOT auto-injected here (removed 2026-10-22): confirmed
  // against the mobile app's own API client that different endpoints expect
  // it in different shapes — flat (`enrolled-sessions`, `sibling`), nested
  // inside a `data` envelope (most list/filter GETs), or not at all
  // (`faq`, `details`, `notifications` default view). Each service function
  // now builds its own params to match that client exactly instead of one
  // global guess.

  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

studentApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default studentApi;
